import React, { ChangeEvent } from "react";
import { Button, Grid } from "@material-ui/core";
import { Add as AddIcon } from "@material-ui/icons";
import ValidationResult from "../../../hooks/change-tracker/ValidationResult";
import SchoolCarrierItem from "./SchoolCarrierItem";
import { SchoolCarrier } from "../../../models/financing-request/SchoolCarrier";
import SelectItem from "../../../models/shared/SelectItem";
import { VehicleType } from "../../../models/vehicle-type/VehicleType";

interface Props {
  schoolCarriers: SchoolCarrier[] | null;
  vehicleTypeItems: SelectItem<VehicleType>[];
  validationResult: ValidationResult;
  onChange: (index: number) => (e: ChangeEvent<HTMLInputElement>) => void;
  onSelectChange: (
    index: number
  ) => (
    e: React.ChangeEvent<{ name?: string | undefined; value: unknown }>
  ) => void;
  onAdd: () => void;
  onDelete: (index: number) => void;
}

export default function CreateSchoolCarrier({
  schoolCarriers,
  vehicleTypeItems,
  validationResult,
  onChange,
  onSelectChange,
  onAdd,
  onDelete
}: Props) {
  return (
    <Grid container spacing={5}>
      {schoolCarriers != null && schoolCarriers.length > 0
        ? schoolCarriers.map((schoolCarrier: SchoolCarrier, index: number) => (
            <SchoolCarrierItem
              key={index.toString()}
              index={index}
              schoolCarrier={schoolCarrier}
              vehicleTypeItems={vehicleTypeItems}
              onChange={onChange(index)}
              onSelectChange={onSelectChange(index)}
              onDelete={onDelete}
              validationResult={validationResult}
            />
          ))
        : null}
      <Grid item xs={12}>
        <Button variant="outlined" color="primary" size="small" onClick={onAdd}>
          <AddIcon />
          Dodaj školski prijevoz
        </Button>
      </Grid>
    </Grid>
  );
}
